// @flow

import stores from 'stores';

export default (storeId: string, data: TStoreOpeningHours) => {
  return stores.doddleStores.updateStoreOpeningHours(storeId, data);
};
